
import Image from 'next/image';
import arrowRightPng from './images/arrow-right.svg';

interface IPage {
    current: number;
    total: number;
    enableLeft: boolean;
    enableRight: boolean;
    onPrev: () => void;
    onNext: () => void;
    className?: string;
  }
  export const ArrowPage: React.FC<IPage> = ({
    current,
    total,
    enableLeft,
    enableRight,
    onPrev,
    onNext,
    className = ''
  }) => {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <div
          onClick={onPrev}
          className={`h-10 w-10 rounded-full border-page border border-solid flex justify-center items-center ${
            enableLeft ? 'cursor-pointer' : 'cursor-not-allowed bg-page-bg/30'
          }`}
        >
          <Image
            src={arrowRightPng}
            alt="left icon"
            width={5}
            height={8}
            className="h-2 w-full rotate-180"
          />
        </div>
        <span className="text-primary/60 leading-none mx-5 text-sm">
          {current}/{total}
        </span>
        <div
          onClick={onNext}
          className={`h-10 w-10 rounded-full border-page border border-solid flex justify-center items-center ${
            enableRight ? 'cursor-pointer' : 'cursor-not-allowed bg-page-bg'
          }`}
        >
          <Image
            src={arrowRightPng}
            alt="left icon"
            width={5}
            height={8}
            className="h-2 w-full"
          />
        </div>
      </div>
    );
  };